export const getFantomTokenLogoURL = (address: string) => {
  return `https://raw.githubusercontent.com/sushiswap/logos/main/network/fantom/${address}.jpg`
}
